import {
  CustomerConditionType,
  CustomerQueryType,
} from 'lib/graphql/storeadmin'

export const staticCustomerType = {
  personal: 'PERSONAL',
  corporate: 'CORPORATE',
  unregistered: 'UNREGISTERED',
}

export const commonSelectedOption = {
  phone: '電話番号',
  address__city: '市区町村',
  email: 'メールアドレス',
}
export const corporateSelectedOption = {
  corporation_name: '法人・団体名',
  last_name: '担当者 姓',
  first_name: '担当者 名',
  ...commonSelectedOption,
}

export const personalSelectedOption = {
  last_name: '姓',
  first_name: '名',
  ...commonSelectedOption,
}
export const customerTypeInput = {
  condition: CustomerConditionType.Equal,
  field: 'type',
  type: CustomerQueryType.And,
}
